export const START_DOWNLOAD_VOUCHERS = 'START_DOWNLOAD_VOUCHERS';
export const DOWNLOAD_VOUCHER_SUCCESS = 'DOWNLOAD_VOUCHER_SUCCESS';
export const DOWNLOAD_VOUCHER_ERROR = 'DOWNLOAD_VOUCHER_ERROR';

//Types para anular comprobante
export const CANCEL_VOUCHER = 'CANCEL_VOUCHER';
export const CANCEL_VOUCHER_SECCESS = 'CANCEL_VOUCHER_SECCESS';
export const CANCEL_VOUCHER_ERROR = 'CANCEL_VOUCHER_ERROR';
export const CANCEL_VOUCHER_CLEAR = "CANCEL_VOUCHER_CLEAR";
//Types para listar vouchers anulados
export const START_DOWNLOAD_CVOUCHERS = 'START_DOWNLOAD_CVOUCHERS';
export const DOWNLOAD_CVOUCHER_SUCCESS = 'DOWNLOAD_CVOUCHER_SUCCESS';
export const DOWNLOAD_CVOUCHER_ERROR = 'DOWNLOAD_CVOUCHER_ERROR';

//Types para obtener vouches autorizados
export const START_AUTHORIZED_VOUCHERS = 'START_AUTHORIZED_VOUCHERS';
export const AUTHORIZED_VOUCHERS_SECCESS = 'AUTHORIZED_VOUCHERS_SECCES';
export const AUTHORIZED_VOUCHERS_ERROR = 'AUTHORIZED_VOUCHERS_ERROR';
export const CLEAR_AUTHORIZED_VOUCHERS = "CLEAR_AUTHORIZED_VOUCHERS";

//Types para búsqueda de vouchers autorizados
export const START_SEARCHAUT_VOUCHERS = 'START_SEARCHAUT_VOUCHERS';
export const SEARCHAUT_VOUCHERS_SECCES = 'SEARCHAUT_VOUCHERS_SECCES';
export const SEARCHAUT_VOUCHERS_ERROR = 'SEARCHAUT_VOUCHERS_ERROR';
export const SEARCHAUT_VOUCHERS_CLEAR = 'SEARCHAUT_VOUCHERS_CLEAR';

//Types for number of vouchers available
export const SATRT_GET_NUMBER = 'SATRT_GET_NUMBER';
export const GET_NUMBER_VOUCHERS = 'GET_NUMBER_VOUCHERS';
export const GET_NUMBER_SUCCESS = 'GET_NUMBER_SUCCESS';
export const GET_NUMBER_ERROR = 'GET_NUMBER_ERROR';


export const SET_VOUCHER_TO_DUPLICATE = 'SET_VOUCHER_TO_DUPLICATE';
export const CLEAR_VOUCHER_TO_DUPLICATE = 'CLEAR_VOUCHER_TO_DUPLICATE';